import React, { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';

type CardEventFeatureProps = {
  icon: ReactNode;
  title: string;
  subtitle: string;
  fullCard?: boolean;
};

export const CardEventFeature: React.FunctionComponent<CardEventFeatureProps> = ({
  icon,
  title,
  subtitle,
  fullCard,
}) => {
  const textStyles = {
    fontSize: { lg: fullCard ? 20 : 16, md: fullCard ? 18 : 14, sm: 14, xs: 14 },
  };

  return (
    <Stack direction="row" justifyContent="space-between" columnGap="8px">
      {icon}
      <Stack>
        <Typography
          variant="h4"
          color="secondary.main"
          mb="4px"
          whiteSpace="nowrap"
          sx={textStyles}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="secondary.main"
          whiteSpace="nowrap"
          className="link-subtitle"
          sx={textStyles}
        >
          {subtitle}
        </Typography>
      </Stack>
    </Stack>
  );
};
